import TableNew, { CELL_TYPES } from "../../../../shared/Table";

const AmlTableComponent = ({ notes }) => {
  const columns = [
    { key: "Created", label: "Date", visible: true, type: CELL_TYPES.date },
    { key: "Author", label: "Author", visible: true, type: CELL_TYPES.text },
    { key: "Text", label: "Note", visible: true, type: CELL_TYPES.text },
  ];

  return (
    <TableNew columns={columns} tableKey={"amlNotesTable"} items={notes} />
  );
};

export default AmlTableComponent;
